const OPERATIONAL_OVERVIEW_PROJECT_TYPES = new Set(['Vendor Due Diligence', 'Post-Merger Integration']);

/** VDD & PMI — Figma PMI layout (6849:8414 … 6849:9789): operational row first, then VDR/IRL. */
export function usesOperationalOverviewLayout(projectType) {
    return OPERATIONAL_OVERVIEW_PROJECT_TYPES.has(projectType);
}

/** @deprecated Use usesOperationalOverviewLayout */
export function usesLegacyOverviewLayout(projectType) {
    return usesOperationalOverviewLayout(projectType);
}
